import { useNavigate } from 'react-router';
import { toast } from '@lib/ui';
import type { WizardPersona } from '../types';
import { InterviewWizard } from './index';

export default function InterviewWizardPage() {
  const navigate = useNavigate();

  const handleComplete = (persona: WizardPersona) => {
    toast.success(`Persona "${persona.name}" created successfully!`);
    navigate('/personas');
  };

  const handleCancel = () => {
    navigate('/poc/wizards');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900 flex items-center justify-center p-6">
      <InterviewWizard isOpen={true} onClose={handleCancel} onComplete={handleComplete} />
    </div>
  );
}
